{
    "l_first_name": "Vorname",
    "l_last_name": "Nachname",
    "l_sex": "Geschlecht",
    "l_year_born": "Geburtsjahr",
    "l_occupation": "Beruf",
    "l_no_results": "Keine Suchergebnisse",
    "l_condition_include": "beinhaltet",
    "l_search_settings": "Sucheinstellungen",
    "l_male": "männlich",
    "l_female": "weiblich",
    "l_academic_title": "Akademischer Titel",
    "l_confession": "Konfession",
    "l_dienstgrad": "Dienstgrad",
    "l_deceived": "Gestorben",
    "l_wohnorte": "Wohnorte",
    "l_buergerorte": "BÜrgerorte",
    "l_directories": "Verzeichnisse",
    "l_remarks": "Bemerkungen",
    "l_sources": "Quellen",
    "l_parties": "Parteien",
    "l_einsitze": "Einsitze",
    "l_conncetions": "Verbindungen",
    "l_picture": "Bild",
    "l_functions": "Funktionen",
    "l_function": "Funktion",
    "l_dict_dnb": "Katalog der Deutschen Nationalbibliothek",
    "l_dict_hls": "Das Historische Lexikon der Schweiz (HLS)",
    "l_time_join": "Eintritt",
    "l_time_exit": "Austritt",
    "l_wahlkreis": "Wahlkreis",
    "l_wahlkreise": "Wahlkreise",
    "l_from": "von",
    "l_until": "bis",
    "l_since": "seit",
    "l_fraktion": "Fraktion",
    "l_fraktionen": "Fraktionen",
    "l_all": "alle",
    "l_born_before": "Geboren vor",
    "l_born_after": "Geboren nach",
    "l_party_membership": "Parteizugehörigkeit",
    "l_short_name": "Kurzname",
    "l_mandates": "Mandate",
    "l_political_activities": "Poltische Aktivitäten",
    "l_email": "Email",
    "l_email_private": "Email Privat",
    "l_mobile": "Mobil",
    "l_mobile_private": "Mobil Privat",
    "l_telephone": "Telefon",
    "l_telephone_private": "Telefon Privat",
    "l_address": "Adresse",
    "l_anrede": "Anrede",
    "l_party": "Partei",
    "l_zip_code": "Postleitzahl",
    "l_spouse": "Partner",
    "l_zivilstand": "Zivilstand",
    "l_search": "suchen",
    "l_reset": "zurücksetzen",
    "l_männlich": "männlich",
    "l_weiblich": "weiblich",
    "l_gremium": "Gremium",
    "l_title": "Titel",
    "l_type": "Typ",
    "l_date": "Datum",
    "l_time": "Zeit",
    "l_traktanden": "Traktanden",
    "l_number_short": "Nr.",
    "l_documents": "Dokumente",
    "l_video": "Video",
    "l_members": "Mitglieder",
    "l_additional_infos": "Weitere Informationen",
    "l_kommission": "Kommission",
    "l_kommissionen": "Kommissionen",
    "l_sitzungen": "Sitzungen",
    "l_contact_data": "Kontaktdaten",
    "h1_fraktionen": "Fraktionen",
    "h1_kommissionen": "Kommissionen",
    "h1_mitglieder": "Miglieder",
    "h1_sitzungen": "Sitzungen Kantonsrat und Kommissionen",
    "h1_wahlkreise": "Wahlkreise Kanton Zürich",
    "h1_personen": "Mitglieder des Kantonsrates Zürich seit 1803",
    "h1_kantonsrat": "Kantonsrat",
    "st_search_persons": "Personensuche",
    "l_data": "Daten",
    "l_ort": "Ort",
    "l_geschaefts_art": "Geschäftsart",
    "h1_geschaefte": "Geschäfte",
    "l_pendent_bei": "Pendent bei",
    "l_beginn": "Beginn",
    "l_role": "Rolle",
    "l_participation": "Beteiligung",
    "l_direktion": "Direktion",
    "l_politische_gemeinde": "Politische Gemeinde",
    "l_ablauf": "Ablauf",
    "l_status": "Status",
    "l_frist": "Frist",
    "l_sitzungs_datum": "Sitzungsdatum",
    "l_geschaefte": "Geschäfte"
}